import { useQuery } from '@tanstack/react-query';
import { AuthMethod } from 'src/auth/settings/types';

type PublicTenantConfig = {
  authMethod: AuthMethod;
};

export const usePublicTenantConfig = (tenantName: string | undefined) => {
  const { data, isLoading, isError, error } = useQuery<PublicTenantConfig>({
    queryKey: ['public', `tenant-config/${encodeURIComponent(tenantName ?? '')}`],
    enabled: !!tenantName,
    retry: false,
    staleTime: 2_000,
  });

  return {
    config: data ?? { authMethod: 'password' as const },
    isLoading,
    isError,
    error,
  };
};
